import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import Constants from '../Constants';
import { doVxqlRequest } from './VxqlStore/common.js';

function getSpinwheelInfo(callback, type) {
	const variables = type ? { type } : {};

	let additionalQuery;

	switch (type) {
		case Constants.Spinwheel.Types.goldrausch:
			additionalQuery = `
            coinLoyaltyBonusState
              spinRewardHistory(type: $type) {
                id
                type
                dateRedeemed
                bonuscode {
                  code
                  type
                  value
                  isRedeemed
                }
                coins {
                  amount
                }
              }
            `;
			break;
		default:
			additionalQuery = `
              points(currentMonthOnly: true)
		      spins
              monthlyRewards {
				id
				isRedeemed
				isRedeemable
				requiredPoints
				type
				bonuscode {
				  code
				  type
				  value
				}
				voucher {
				  amount
				}
				messengerGift {
				  id
				  name
				  price {
					value
					currency
					symbol
				  }
				  imageUrl
				  active
				  vip
				  categoryId
				  translations {
					language
					name
					value
				  }
				}
				freeSpins {
				  amount
				}
			  }
            `;
	}

	const query = `
		query($type: LoyaltyPointsSpinwheelType) {
		  guest {
		    loyaltyPoints {
		      spinwheelActive(type: $type)
		      lastSpinDate(type: $type)
              ${additionalQuery}
		    }
		  }
		}`;

	doVxqlRequest(query, variables).then((result) => callback(result));
}

function doSpinwheelSpin(callback, type) {
	const variables = type ? { type } : {};
	const query = `
	mutation($type: LoyaltyPointsSpinwheelType) {
	guest {
		loyaltyPoints {
			doSpin(type: $type) {
				type
				bonuscode {
					code
					type
					value
				}
				coins {
					amount
				}
				freeSpins {
					amount
				}
				messengerGift {
					imageUrl
					translations {
						language
						value
					}
				}
				voucher {
					amount
				}
			}
		}
	}
	}`;

	doVxqlRequest(query, variables).then((result) => callback(result));
}

function redeemLoyaltyPointsReward(id, callback) {
	const query = `
	mutation($id: Int!) {
		guest {
		  loyaltyPoints {
			redeemReward(id: $id)
		  }
		}
	  }
	`;

	doVxqlRequest(query, { id }).then((result) => callback(result));
}

function tryLoyaltyPointsMigrate(callback) {
	const query = `
	mutation {
		guest {
		  loyaltyPoints {
			tryMigrate
		  }
		}
	  }
	`;

	doVxqlRequest(query).then((result) => callback(result));
}

function claimCoins(callback) {
	const query = `
	mutation {
        guest {
            loyaltyPoints {
                claimCoinLoyaltyBonus
            }
        }
	}`;

	doVxqlRequest(query, {}).then((result) => callback(result));
}

const SpinwheelStore = assign({}, FluxEventEmitter.prototype, {
	getSpinwheelInfo(callback, type) {
		getSpinwheelInfo(callback, type);
	},

	doSpinwheelSpin(callback, type) {
		doSpinwheelSpin(callback, type);
	},

	redeemLoyaltyPointsReward(id, callback) {
		redeemLoyaltyPointsReward(id, callback);
	},

	tryLoyaltyPointsMigrate(callback) {
		tryLoyaltyPointsMigrate(callback);
	},

	claimCoins(callback) {
		claimCoins(callback);
	},
});

export default SpinwheelStore;